export default __webpack_public_path__ + "static/media/art_wheel_border.b6e47d95.svg";